import { memMonitorWorker } from './worker';
import { slardar } from '@meego/biz-utils/src/monitors/slardar';

enum MemoryEvent {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  REGULAR = 'regular',
}

type memoryUploadData = {
  type: MemoryEvent;
  increment: number;
  usedSize: number;
  limitSize: number;
  usageRate: number;
};

class MemoryMonitor {
  viewMode: string = 'unknown';
  monitor: Worker;
  count: number = 0;

  init(onReport?: (data: memoryUploadData) => void) {
    this.monitor = new Worker(memMonitorWorker);

    this.monitor.onmessage = res => {
      const record = res.data;
      this.report(record.type as MemoryEvent, record);
      onReport?.(record);
    };

    setInterval(() => {
      const { usedJSHeapSize, jsHeapSizeLimit } = performance.memory;
      this.monitor.postMessage({ usedJSHeapSize, jsHeapSizeLimit });
    }, 1000);
  }

  // 分单次、多次、常规类型的上报
  report(event: MemoryEvent, record: memoryUploadData) {
    const data = { ...record } as any;
    delete data.type;
    slardar.sendCustom(`memory_monitor_${event}`, data);
  }
}

export const memoryMonitor = new MemoryMonitor();
